import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { CampaignFormComponent } from '@campaign-form/campaign-form.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { map } from 'rxjs';

export const campaignFormLeaveGuard: CanDeactivateFn<CampaignFormComponent> = (component) => {
  const dialog = inject(MatDialog);
  const translate = inject(TranslateService);

  if (!component.sectionChanged()) {
    return true;
  }

  const dialogRef = dialog.open(ConfirmDialogComponent, {
    data: {
      cancelText: translate.instant('pages.campaignForm.confirmDialog.stay'),
      confirmText: translate.instant('pages.campaignForm.confirmDialog.leave'),
      message: translate.instant('pages.campaignForm.confirmDialog.message'),
      swapButtons: true,
      title: translate.instant('pages.campaignForm.confirmDialog.title'),
    },
    width: '400px',
  });

  return dialogRef.afterClosed().pipe(
    map((result) => {
      if (result) {
        component.campaign.set(structuredClone(component.campaign()!));

        return true;
      }

      return false;
    }),
  );
};
